import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NavController,NavParams,ToastController,AlertController  } from 'ionic-angular';
import { DTOTam } from '../../dto/dtoTam';
import { DTOInformacaoUsuario } from '../../dto/dtoInfomacaoUsuario';
import { PedidoDAO } from '../../daos/pedido-dao';
import { Pix } from '../../entities/pix';
import {NgxImageCompressService} from 'ngx-image-compress';
import { MenuComponent } from '../../components/menu/menu';

//npm i ngx-image-compress@7.2.4
//https://www.npmjs.com/package/ngx-image-compress?activeTab=versions

interface Banco {
  Nome: string;
}

@Component({
    selector: 'page-solicitar-pix',
    templateUrl: 'solicitar-pix.html'
})
export class SolicitarPixPage {
    public pix: Pix = new Pix();
    public formPedido: FormGroup;
    public blEnviar: boolean=false;
    public base64ImageFrente: string = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA8AAAAMcAQMAAACl5F6MAAAABlBMVEW8vsDn6OnyCdevAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEbUlEQVR4AezBMQEAAADCoPVP7WsIoAcAAAAAAAAAAAAAAAAAAAAAAIydO0iOk4eCAGyVXNEuukF0FB1NHE1H0RG0ZEHRf5A99WYMk1T+Kvolw+vVjBf+CkMLoRCFWQkuqCquB3QOOQKrCpwBKJ1i6Jxk/EzTubaArgAHQOeyjhu8aMEafUrYolLjLRMfLrpw5cMYadeBnTLcrwN7ZXi+DhyuCi8GG/xy8Gyw3SRe7n7cLzfnajah5z87keFJ//lYf0WAAq+vv+rDX+fir+zpr2Xqr95qrle/ywr9OxX+/nF19fGRmR/yrzCJCudRqNHiNDHhIlquTBgCF2aX3V2BwYT9nUYdNoNojnqjiKJ56q0xiRaok4EsWqQO2EW0RJ3wQbTMvDc6iFaYswEvkx5Hnf8E0Tx1xhcfj3gh1lhOLHVWnx8vLvBq/FAnYpGBhwEElVfjhyETjVjj5bFanATpLrHIcpDkIstpJRdZLmRykaW63CLLMZKLLGeVXGS5jvlFluZKq8k1lnGMXGMZuck1lnsVu8ZydybXWOYj5BrLDIxcY5lz8mrML/JupPIC02osf3tyjeVqY9dYikys8QlTAUIsFovFYrFYLJaIP8hq8D4GG2ywwQYbbLDBBhtssMEGG2ywwQYb3N9+G/ePwQYbbLDBBhtssMEGG5yhA3ugqcARmFXgDKwqcAGgAsu+J1zYy94UXDjIRxosH+crwUm2euHCWX43Fy7YciUYI9N1YIeRavDpsMdIM9jgs+BOh4PBavA3ras6aMFRC06TEpyrLsy/H5emBKOrwvxZpsOsA3ssOk8SQQ9edZ4WI6DzfJwU4Ym/FCE7ofFXfQoJlnUugRsHdl9GTKBzlxRF6vzVW9kngr5eLTB5hT6MUhPgLfdDRhwQCQ79TQXe756tAWcp10XgIuMYF8aWxoedLtz5sB/wzIeDLrzw4QiRqHBSgOvnwLWFCrc7eCLCbnwrXFh2ZMdHKhEOyx3ciHBch8OHE2TtCZ0IZ0wCz1S4jhGTDhc0ecN9IcLja/qEVwIswqwC+/H3zfgMDw7j95cbPBFg+YEKnIaGWyoNzpvmcEujws0rwGX7LnCnwWOgDLhlZsFuaJEP+zFCC7yw4DCAhFtWFhwHl/lwwpeowRMJzlpw+QpXEgwl2O3gxoH9Du4cOOzgmQNHLTjt4OXF4byDVw5csAsHhhLssM/EgD32qQw4aMER+zQtuDPgpAVn7DMz4IJ9FgYMJdgdwSsB9jgKAQ5acDyEJy24ng8nLTgfwu18uBzC/XwYSrA7hmfCeyCHWU6Hw18Gr4R3fY5zOpy04PwEngj/KfYw9WwYSrB7BjfCW4qH6a8Kh2fwTHgF9jDLyXDSgvMzeKW8UX6Uk2Eowe45PL0m7J/D9VQ4aMG/isH/JwYbbLDBBhtssMEGG2ywtz3K/2tvDmQAAAAABvlbn+NbCSQWi8VisVgsFovFYrFYLBYvAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEHVJjR5bJLd8AAAAASUVORK5CYII=';
    public base64ImageVerso: string = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA8AAAAMcAQMAAACl5F6MAAAABlBMVEW8vsDn6OnyCdevAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEbUlEQVR4AezBMQEAAADCoPVP7WsIoAcAAAAAAAAAAAAAAAAAAAAAAIydO0iOk4eCAGyVXNEuukF0FB1NHE1H0RG0ZEHRf5A99WYMk1T+Kvolw+vVjBf+CkMLoRCFWQkuqCquB3QOOQKrCpwBKJ1i6Jxk/EzTubaArgAHQOeyjhu8aMEafUrYolLjLRMfLrpw5cMYadeBnTLcrwN7ZXi+DhyuCi8GG/xy8Gyw3SRe7n7cLzfnajah5z87keFJ//lYf0WAAq+vv+rDX+fir+zpr2Xqr95qrle/ywr9OxX+/nF19fGRmR/yrzCJCudRqNHiNDHhIlquTBgCF2aX3V2BwYT9nUYdNoNojnqjiKJ56q0xiRaok4EsWqQO2EW0RJ3wQbTMvDc6iFaYswEvkx5Hnf8E0Tx1xhcfj3gh1lhOLHVWnx8vLvBq/FAnYpGBhwEElVfjhyETjVjj5bFanATpLrHIcpDkIstpJRdZLmRykaW63CLLMZKLLGeVXGS5jvlFluZKq8k1lnGMXGMZuck1lnsVu8ZydybXWOYj5BrLDIxcY5lz8mrML/JupPIC02osf3tyjeVqY9dYikys8QlTAUIsFovFYrFYLJaIP8hq8D4GG2ywwQYbbLDBBhtssMEGG2ywwQYb3N9+G/ePwQYbbLDBBhtssMEGG5yhA3ugqcARmFXgDKwqcAGgAsu+J1zYy94UXDjIRxosH+crwUm2euHCWX43Fy7YciUYI9N1YIeRavDpsMdIM9jgs+BOh4PBavA3ras6aMFRC06TEpyrLsy/H5emBKOrwvxZpsOsA3ssOk8SQQ9edZ4WI6DzfJwU4Ym/FCE7ofFXfQoJlnUugRsHdl9GTKBzlxRF6vzVW9kngr5eLTB5hT6MUhPgLfdDRhwQCQ79TQXe756tAWcp10XgIuMYF8aWxoedLtz5sB/wzIeDLrzw4QiRqHBSgOvnwLWFCrc7eCLCbnwrXFh2ZMdHKhEOyx3ciHBch8OHE2TtCZ0IZ0wCz1S4jhGTDhc0ecN9IcLja/qEVwIswqwC+/H3zfgMDw7j95cbPBFg+YEKnIaGWyoNzpvmcEujws0rwGX7LnCnwWOgDLhlZsFuaJEP+zFCC7yw4DCAhFtWFhwHl/lwwpeowRMJzlpw+QpXEgwl2O3gxoH9Du4cOOzgmQNHLTjt4OXF4byDVw5csAsHhhLssM/EgD32qQw4aMER+zQtuDPgpAVn7DMz4IJ9FgYMJdgdwSsB9jgKAQ5acDyEJy24ng8nLTgfwu18uBzC/XwYSrA7hmfCeyCHWU6Hw18Gr4R3fY5zOpy04PwEngj/KfYw9WwYSrB7BjfCW4qH6a8Kh2fwTHgF9jDLyXDSgvMzeKW8UX6Uk2Eowe45PL0m7J/D9VQ4aMG/isH/JwYbbLDBBhtssMEGG2ywtz3K/2tvDmQAAAAABvlbn+NbCSQWi8VisVgsFovFYrFYLBYvAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEHVJjR5bJLd8AAAAASUVORK5CYII=';
    public usuario: DTOInformacaoUsuario = new DTOInformacaoUsuario();
    public dtoTam: DTOTam[];
    public qtdePicote: number;
    public bancos: Banco[];  
    public bancosFiltrado: Banco[] = [];

    constructor(_formBuilder: FormBuilder,private _toastCtrl: ToastController
        ,private _pedidoDao: PedidoDAO
        ,private imageCompress: NgxImageCompressService
        ,private _alertCtrl: AlertController
        ,public navCtrl: NavController,_navParams: NavParams) {        
        this.usuario = _navParams.get('usu');   
        this.qtdePicote = _navParams.get('qtdePicote');

        this.bancos = [{Nome:"001 Banco do Brasil"},{Nome:"033 Santander"},{Nome:"104 Caixa Econômica Federal"}
            ,{Nome:"237 Bradesco"},{Nome:"341 Itaú"},{Nome:"Citibank"},{Nome:"0260 Nubank"}
            ,{Nome:"290 PagSeguro"},{Nome:"380 PicPay"},{Nome:"BV"},{Nome:"Banco Inter"}
            ,{Nome:"Mercado Pago"},{Nome:"Sicoob"},{Nome:"Unicred"},{Nome:"0116 Sicredi"}
            ,{Nome:"Sofisa Direto"},{Nome:"B3"},{Nome:"Neon"},{Nome:"Acesso"},{Nome:"C6 Bank"}
        ];
  
        this.formPedido = _formBuilder.group({
            PrimeiraCartela: ['', Validators.compose([Validators.required])],
            SegundaCartela: ['',''],
            ImgFrente: ['', Validators.compose([Validators.required])],
            ImgVerso: ['', Validators.compose([Validators.required])],
            Obs: ['', Validators.compose([Validators.required])],
            ChavePix: ['', Validators.compose([Validators.required])],
            TipoChavePix: ['', Validators.compose([Validators.required])],
            NomeBanco: ['', Validators.compose([Validators.required])]
        });  

        this.pix.Obs = 'nome titular: '+this.usuario.NomeUsuario;
        
        
    }

    

    public buscaNomeBanco(descricao: string): void {
        if (descricao.length > 1)
            this.bancosFiltrado = this.bancos.filter(banco => `${banco.Nome}`.toUpperCase().indexOf(descricao.toUpperCase()) > -1);
        else
            this.bancosFiltrado = [];
    }

    public selecionaBanco(banco: Banco): void {
        this.bancosFiltrado = [];
        this.pix.NomeBanco = banco.Nome;
    }


    uploadFrente(event:any){

        //var filename = event.target.files[0].name
        var fileReader = new FileReader();
        fileReader.readAsDataURL(event)
        fileReader.onload = () => {
            this.base64ImageFrente = fileReader.result.toString();
            //console.log(this.base64ImageFrente.length);

            this.imageCompress.compressFile(this.base64ImageFrente, 30, 30).then(result => {
                this.base64ImageFrente = result;
                //console.warn('Size in bytes is now:', this.imageCompress.byteCount(result));
              }
            );
        }        

    }

    uploadVerso(event:any){        
        var fileReader = new FileReader();
        fileReader.readAsDataURL(event)
        fileReader.onload = () => {
            this.base64ImageVerso = fileReader.result.toString();
            //console.log(this.base64ImageVerso.length);

            this.imageCompress.compressFile(this.base64ImageVerso, 50, 50).then(result => {
                  this.base64ImageVerso = result;
                  //console.warn('Size in bytes is now:', this.imageCompress.byteCount(result));
                }
              );
        }

    }
    

    eviarPedido() {
       
        if (this.formPedido.invalid) {
            this._toastCtrl.create({
                message: 'O formulário está invalido. Favor Verifique!',
                duration: 3000
            }).present();

            return;
        }
        
        if (this.pix.PrimeiraCartela == this.pix.SegundaCartela){
            this._toastCtrl.create({
                message: 'Cartelas estão iguais. Favor Verifique!',
                duration: 3000
            }).present();
            return;
        }
        
        this.blEnviar = true;

        this.pix.Empresa = this.usuario.Empresa;
        this.pix.IdUsuario = this.usuario.IdUsuario;
        this.pix.CodRepresentante =  this.usuario.CodRepresetante;
        this.pix.ImgFrente = this.base64ImageFrente;
        this.pix.ImgVerso = this.base64ImageVerso;

        if (this.qtdePicote == 50) {
            this.pix.VlrPix = 30
         } else this.pix.VlrPix = 60;

        
        
        
        this.salvarPedido();

    }


    salvarPedido() {
        this._pedidoDao.adicionarPix(this.pix)
                    .then(retorno => {

                        if (retorno=='ok'){
                            this.alertaDeSucesso("Pix enviado para fábrica!");
                            this.navCtrl.setRoot(MenuComponent, { usuario: this.usuario });  
                        }else{
                            this._toastCtrl.create({
                                message: retorno,
                                duration: 3000
                            }).present();
                            return;
                        }
                                      
                    }, e => {
                        this._toastCtrl.create({
                            message: 'Não foi possível adicionar o Pedido'+e,
                            duration: 3000
                        }).present();
                        return;
                });
    }

    alertaDeSucesso(msg: string) {
        this._alertCtrl.create({
            message: msg,
            title: 'Sucesso 😀 ️',
            buttons: [{
                text: 'Ok'
            }]
        }).present();
    }

    public change(): void {
        this.blEnviar = false;
    }
    


}


// WEBPACK FOOTER //
// ./src/pages/solicitar-pix/solicitar-pix.ts